(function() {
    let obj;
 
    Object.defineProperty(window, "tlCartGoalEmbed", {
        get() {
            return obj;
        },
        set(val) {

            if (val && typeof val.getPassedMilestone === "function" && !obj) {
                val.getPassedMilestone = async function (cartTotal = window.tlCartGoalEmbed.cartTotal, firstLoad = false) {
                    const passedMilestone = {
                        gift: -1 ,
                        indexOfPassedFreeGift: -1,
                        freeShipping: -1,
                        discount: -1,
                        lastest: -1
                    }

                    window.tlCartGoalEmbed.milestones.map((milestone, index) => {
                        if(milestone.cart_value <= cartTotal){
                            passedMilestone.lastest = index;
                            switch(milestone.reward_type){
                                case window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT :
                                    passedMilestone.gift = index;
                                    passedMilestone.indexOfPassedFreeGift ++;
                                    break;
                                case window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT :
                                    passedMilestone.discount = index;
                                    break;
                                case window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_SHIPPING :
                                    passedMilestone.freeShipping = index;
                                    break;
                            }
                        }
                    });
                    const oldPassedMilestone = JSON.parse(JSON.stringify(window.tlCartGoalEmbed.passedMilestone));    
                    window.tlCartGoalEmbed.passedMilestone = passedMilestone;
                    let needToRefresh = false;

                    if(window.tlCartGoalEmbed.cartGoal.auto_remove_gift){
                        needToRefresh = await window.tlCartGoalEmbed.handleRemoveGift();
                    }

                    const isAllMilestoneStack = window.tlCartGoalEmbed.cartGoal.reward_stack === window.tlCartGoalEmbed.CART_GOAL_REWARD_STACK.ALL_MILESTONES;      
                    const { 
                        product_discount: productDc,
                        order_discount: orderDc,
                        shipping_discount: shippingDc
                    } = window.tlCartGoalEmbed.discountCode;

                    const discountCodes = [];
                    const discountCodesToRemove = [];

                    if(window.tlCartGoalEmbed.cartGoal.auto_add_reward){
                        if(isAllMilestoneStack && oldPassedMilestone.lastest < passedMilestone.lastest){
                            if(passedMilestone.gift !== -1){
                                if(!window.tlCartGoalEmbed.milestoneIndexMapGift.get(passedMilestone.gift)){
                                    const listMilestoneNeedAutoAdd = []
                                    window.tlCartGoalEmbed.milestones.forEach((milestone, milestoneIndex) =>{
                                        if(
                                        milestone.reward_type === window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT &&
                                        milestoneIndex <= passedMilestone.gift && !window.tlCartGoalEmbed.milestoneIndexMapGift.has(milestoneIndex)
                                        ){
                                            listMilestoneNeedAutoAdd.push(milestoneIndex)
                                        }
                                    })
                                    await window.tlCartGoalEmbed.handleAutoAddMultipleGift(listMilestoneNeedAutoAdd)

                                }else if(!window.tlCartGoalEmbed.appliedDiscounts.includes(productDc)){
                                    discountCodes.push(productDc)
                                }
                            }
                            
                            if(passedMilestone.discount !== -1 && !window.tlCartGoalEmbed.appliedDiscounts.includes(orderDc)){
                                discountCodes.push(orderDc)
                            }
                        }else if(passedMilestone.lastest !== oldPassedMilestone.lastest){
                            if(passedMilestone.lastest == -1){
                                needToRefresh = true;
                            }else {
                                if(passedMilestone.gift == passedMilestone.lastest ){
                                    if(!window.tlCartGoalEmbed.milestoneIndexMapGift.get(passedMilestone.gift)){
                                        await window.tlCartGoalEmbed.handleAutoAddMultipleGift([passedMilestone.gift]);
                                    }else if(!window.tlCartGoalEmbed.appliedDiscounts.includes(productDc)){
                                        discountCodes.push(productDc)
                                    }
                                }else if(passedMilestone.discount == passedMilestone.lastest && !window.tlCartGoalEmbed.appliedDiscounts.includes(orderDc)){
                                    discountCodes.push(orderDc)
                                }else if(passedMilestone.freeShipping == passedMilestone.lastest && !firstLoad){
                                    needToRefresh = true
                                }
                            }
                        }
                    }

                    const discountMappings = {
                        gift: productDc,
                        discount: orderDc,
                        freeShipping: shippingDc,
                    };

                    for (const [key, value] of Object.entries(passedMilestone)) {
                        if (value === -1) {
                            const discountCode = discountMappings[key];
                            if (discountCode && window.tlCartGoalEmbed.appliedDiscounts.includes(discountCode)) {
                                discountCodesToRemove.push(discountCode);
                            }
                        }
                    }

                    if (needToRefresh || discountCodes.length || discountCodesToRemove.length) {
                        if (discountCodesToRemove.length) {
                            await window.tlCartGoalEmbed.removeDiscountCodes(discountCodesToRemove);
                        }
                        if (discountCodes.length) {
                            await window.tlCartGoalEmbed.applyDiscountCode(discountCodes);
                        }

                        if (!window.TLCustomEventCartGoal) {
                            await tlHandleReRenderCart(false);
                        } else if (window.TLCustomEventCartGoal == 1) {
                            window.dispatchEvent(new CustomEvent("TLCustomEvent:CartGoal-getPassedMilestone"));
                        }
                    }
                };
                obj = val;
            }
 
        },
        configurable: true
    });
})();